import React, { useState } from "react";
import Lang from "../../userPreferences/staticWords";
import TextInput from "../sharedComponents/inputs/textInput";
import { useFormik } from "formik";
import Button from "../sharedComponents/buttons/button";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "./formikValidation";
import { login } from "../../API/store/actions/auth";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import StartPage from "../reusableComponents/startPage";
import Spinner from "react-bootstrap/Spinner";
import LoadingPopup from "../layout/loadingPopup";
const Login = () => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const renderModal = () => {
    return <LoadingPopup show={show} onHide={() => setShow(false)} />;
  };
  const submit = async (values) => {
    dispatch(login(values, setDisable, setContent, setShow));
  };

  const formik = useFormik(
    formikSetup(initialValues, {}, validationSchema, "loginPage", submit)
  );
  const { errors, touched, handleSubmit, handleChange, values } = formik;
  const [content, setContent] = useState("دخول");
  const [disable, setDisable] = useState(false);
  return (
    <>
      <StartPage title={Lang.loginMessage}>
        <form onSubmit={handleSubmit} style={{ display: "contents" }}>
          <div className="mx-2 my-3 d-flex flex-column justify-content-center align-items-center">
            <TextInput
              className="py-4"
              name={"username"}
              value={values.username}
              onChange={handleChange}
              errorMessage={formikValidation(touched, errors, "username")}
              type={"text"}
              hiddenPlaceholder={Lang.username}
              containerStyle={"col-md-9 my-2"}
              style={{ textAlign: "left" }}
            ></TextInput>
            <TextInput
              className="py-4"
              name={"password"}
              value={values.password}
              onChange={handleChange}
              errorMessage={formikValidation(touched, errors, "password")}
              type={"password"}
              hiddenPlaceholder={Lang.password}
              containerStyle={"col-md-9 my-2"}
              style={{ textAlign: "left" }}
            ></TextInput>
            {/* </div> */}

            {/* <div className="row"> */}
            {/* <div className="col-12 p-0 d-flex justify-content-center mt-5 p-2"> */}
            <Button
              type={"submit"}
              buttonStyleType={"solid"}
              content={content}
              containerStyle={" col-md-6 mx-3 mb-2 mt-5"}
              onClick={() => {
                setContent(
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  </>
                );
              }}
              disable={disable}
            />
            {/* <div className="col-12 d-flex justify-content-between mx-3 my-3">
              <div> </div> */}
            <div
              style={{ cursor: "pointer" }}
              className="confirmMail text-primary mt-3"
            >
              <Link to={"/confirmMail"} style={{ color: "rgb(46 146 166)" }}>
                نسيت كلمة المرور
              </Link>
            </div>
          </div>
          {/* </div> */}
          {/* </div> */}
        </form>
      </StartPage>
      {renderModal()}
    </>
  );
};

export default Login;
// resetpassword
//
